const React = require("react")
const { Edit } = require("./edit")

module.exports = {
  Edit: (props) => <Edit {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/descriptionInvoiceHeader/index.js